import Table from '@/components/table/components/Table.tsx';
import { usersApiQueryKeys } from '@/features/dashboard/users/api/usersApi.queryKeys.ts';
import { usersApi } from '@/features/dashboard/users/api/usersApi.ts';

const UsersTable = () => {
  return (
    <Table
      queryKey={usersApiQueryKeys.all()}
      fetchData={usersApi.getUsers}
      fetchTableDef={usersApi.getTableDefinition}
    />
  );
};

export default UsersTable;
